var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeatherWidgetThunder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 212 140",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m182.77 27.707v1.5h1.52c14.41 0 26.207 11.797 26.207 26.209 0 14.41-11.797 26.207-26.207 26.207h-38.396v1.5c0 14.41-11.796 26.207-26.209 26.207h-64.065c-14.412 0-26.209-11.797-26.209-26.207v-1.5h-1.7066c-14.41 0-26.207-11.797-26.207-26.207 0-14.412 11.797-26.209 26.207-26.209h38.584v-1.5c0-14.41 11.797-26.207 26.207-26.207h64.068c14.41 0 26.207 11.797 26.207 26.207z",
    fill: "#FFFFFE",
    stroke: "#DBDCD6",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m184.29 27.707h-0.02c0-15.239-12.469-27.707-27.707-27.707h-50.566v110.83h13.688c15.241 0 27.709-12.468 27.709-27.707h36.896c15.239 0 27.707-12.468 27.707-27.707 0-15.241-12.468-27.709-27.707-27.709z",
    fill: "#DBDCD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.91 40.287-25.379 60.147c-7.526 17.84 4.819 38.156 24.167 38.941 0.402 0.016 0.806 0.025 1.212 0.025s0.811-9e-3 1.211-0.025c19.348-0.785 31.694-21.101 24.166-38.941l-25.377-60.147z",
    fill: "#98D1D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.28 100.43-25.377-60.147v99.113c0.406 0 0.811-9e-3 1.211-0.025 19.348-0.785 31.694-21.101 24.166-38.941z",
    fill: "#87B3BB"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherWidgetThunder);
export default __webpack_public_path__ + "static/media/weather-widget_thunder.821a179c.svg";
export { ForwardRef as ReactComponent };